import React from 'react';
import { Row } from 'react-bootstrap';
import { FormNumber, Fieldset } from '~/components/FormControl';

function AttackAndDefense() {
    return (
        <Fieldset className={'px-4'}>
            <Fieldset.Legend>Attack & Defense:</Fieldset.Legend>
            <Row>
                <FormNumber
                    name="addonAttack"
                    isNegativeAllowed
                    sm={6}
                />
                <FormNumber
                    name="addonDefense"
                    isNegativeAllowed
                    sm={6}
                />
            </Row>
        </Fieldset>
    );
}

export default AttackAndDefense;
